"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOCIAL_LINKS = exports.FooterSocials = void 0;

var _atoms = require("../../atoms");

var _jsxRuntime = require("react/jsx-runtime");

var SOCIAL_LINKS = [{
  url: 'https://twitter.com/mycrypto',
  icon: 'twitter'
}, {
  url: 'https://www.facebook.com/mycryptoHQ/',
  icon: 'facebook'
}, {
  url: 'https://medium.com/mycrypto',
  icon: 'medium'
}, {
  url: 'https://www.linkedin.com/company/mycrypto',
  icon: 'linkedin'
}, {
  url: 'https://github.com/MyCryptoHQ',
  icon: 'github'
}, {
  url: 'https://www.reddit.com/r/mycrypto/',
  icon: 'reddit'
}, {
  url: 'https://discord.gg/VSaTXEA',
  icon: 'discord'
}, {
  url: 'https://t.me/mycryptohq',
  icon: 'telegram'
}];
exports.SOCIAL_LINKS = SOCIAL_LINKS;

var FooterSocials = function FooterSocials() {
  return (0, _jsxRuntime.jsx)(_atoms.Flex, {
    flexDirection: "row",
    my: "16px",
    children: SOCIAL_LINKS.map(function (social, index) {
      return (0, _jsxRuntime.jsx)(_atoms.Body, {
        as: "a",
        href: social.url,
        rel: "noreferrer noopener",
        mr: "15px",
        children: (0, _jsxRuntime.jsx)(_atoms.Icon, {
          type: social.icon,
          width: "13px",
          fill: "white",
          sx: {
            verticalAlign: 'middle'
          }
        })
      }, index);
    })
  });
};

exports.FooterSocials = FooterSocials;